export default __webpack_public_path__ + "static/media/qaimera.f93fd53b.png";